import React from 'react'
import Slider from "react-slick";

export default function GoaPlace() {
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1100,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
        responsive: [
            {
            breakpoint: 991,
            settings: { slidesToShow: 2,},
            },
            {
            breakpoint: 767,
            settings: { slidesToShow: 2,},
            },
            {
            breakpoint: 599,
            settings: { slidesToShow: 1,},
            },
        ],
    };

  return (
    <>
    <section className="goa-placearea">
        <div className="container">
            <div className="row justify-content-center">

                <div className="col-lg-8 col-md-9">
                    <div className="goa-shapeheading">
                        <h3 className='heading'>Look Around Our Place</h3>
                        <img src="/image/bigimage-shape.webp" alt="shape" loading="lazy"/>
                        <p>Discover the beautiful surroundings that make every stay more memorable, from peaceful nature spots to nearby attractions waiting to be explored. Step outside and experience the charm, culture, and scenic beauty that surrounds our location.</p>
                    </div>
                </div>

                <div className="col-lg-12">
                    <Slider {...settings} className="goaplace-slider">
                        <div className="goaplace-box">
                            <img src="/image/goa-place-1.webp" loading="lazy" className="img-responsive" alt="Place"/>
                            <div>
                                <img src="/image/goaplace-icon-1.webp" loading="lazy" alt="icon"/>
                                <p>Food & Beverage</p>
                            </div>
                        </div>

                        <div className="goaplace-box">
                            <img src="/image/goa-place-2.webp" loading="lazy" className="img-responsive" alt="Place"/>
                            <div>
                                <img src="/image/goaplace-icon-2.webp" loading="lazy" alt="icon"/>
                                <p>Poolside</p>
                            </div>
                        </div>

                        <div className="goaplace-box">
                            <img src="/image/goa-place-3.webp" loading="lazy" className="img-responsive" alt="Place"/>
                            <div>
                                <img src="/image/goaplace-icon-3.webp" loading="lazy" alt="icon"/>
                                <p>Gym</p>
                            </div>
                        </div>

                        <div className="goaplace-box">
                            <img src="/image/goa-place-4.webp" loading="lazy" className="img-responsive" alt="Place"/>
                            <div>
                                <img src="/image/goaplace-icon-4.webp" loading="lazy" alt="icon"/>
                                <p>Lift Lobby</p>
                            </div>
                        </div>

                        <div className="goaplace-box">
                            <img src="/image/goa-place-5.webp" loading="lazy" className="img-responsive" alt="Place"/>
                            <div>
                                <img src="/image/goaplace-icon-5.webp" loading="lazy" alt="icon"/>
                                <p>Bar Lounge</p>
                            </div>
                        </div>

                        <div className="goaplace-box">
                            <img src="/image/goa-place-6.webp" loading="lazy" className="img-responsive" alt="Place"/>
                            <div>
                                <img src="/image/goaplace-icon-6.webp" loading="lazy" alt="icon"/>
                                <p>Music & DJ Nights</p>
                            </div>
                        </div>
                    </Slider>
                </div>

            </div>
        </div>
    </section>  
    </>
  )
}
